import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { Provider } from 'react-redux';
import i18n from './i18n';
import App from './App';
import theme from './theme';
import { store } from './app/store';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';

let refreshingServiceWorker = false;

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.navigator.serviceWorker?.addEventListener('controllerchange', () => {
      if (refreshingServiceWorker) {
        return;
      }

      refreshingServiceWorker = true;
      window.location.reload();
    });

    registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
  },
});
